module.exports = __webpack_public_path__ + "img/ammiraglio 8 .f1632963.jpeg";